/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import { APIErrorSchema } from "./APIErrorSchema.ts"
import { followedUserProfileSchema } from "./followedUserProfileSchema.ts"
import { z } from "zod/v4"

/**
 * @description Successfully fetched the encrypted profile data for all users you follow
 */
export const getFollowing200Schema = z.object({
  get followedUsers() {
    return z.array(followedUserProfileSchema)
  },
})

/**
 * @description The \"Authorization\" header does not contain a valid Bearer access token.
 */
export const getFollowing401Schema = APIErrorSchema

export const getFollowingQueryResponseSchema = getFollowing200Schema
